module.exports = __webpack_public_path__ + "static/media/ic_no_messages.687ae2d1.svg";